
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

export default {
name: "edit-info",
components: {
XHeader,XInput,Group, Cell
},
data(){
return {
stunum:'',
gender:'女',
stu:{
mothername:'说的',
mothertel:'110',
fathername:'水电费',
fathertel:'124',
address:"陕西省西安市长安区"
},
info:{
grade:'2017',
depart:'新客源',
major:'计科',
class:'计科1班'
}
}
},
mounted(){
this.stunum = this.$store.state.stu_num;
},
methods:{
editpic(){
this.$router.push({name: 'editpic', params: {stunum: this.stunum}})
},
editphonenum(){
this.$router.push({name: 'changephonenum', params: {stunum: this.stunum}})
},
editpass(){
this.$router.push({name: 'changepass', params: {stunum: this.stunum}})
}
}
}



// WEBPACK FOOTER //
// ./src/components/EditInfo.vue